import { Grid } from '@mui/material';
import { styled } from '@mui/material/styles';

export const SwitchGrid = styled(Grid)`
  justify-content: center;
  align-items: center;
`;